import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import { useAuth } from '../context/AuthContext';
import { toast } from 'sonner';

function Register() {
  const navigate = useNavigate();
  const { register } = useAuth();
  const [formData, setFormData] = useState({
    email: '',
    password: '',
    name: '',
    preferred_language: 'de'
  });
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      await register(formData.email, formData.password, formData.name, formData.preferred_language);
      toast.success('Erfolgreich registriert!');
      navigate('/');
    } catch (error) {
      console.error('Registration error:', error);
      toast.error('Registrierung fehlgeschlagen. Bitte versuchen Sie es erneut.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#FAFAFA] dark:bg-[#0A0A0A] flex items-center justify-center px-4 py-12">
      <div className="w-full max-w-md">
        <div className="text-center mb-8">
          <h1 className="text-3xl font-extrabold tracking-tight text-[#09090B] dark:text-[#FAFAFA] mb-2">
            Konto erstellen
          </h1>
          <p className="text-[#52525B] dark:text-[#A1A1AA]">
            Registrieren Sie sich für Smart Short News
          </p>
        </div>

        <div className="bg-white dark:bg-[#121212] rounded-2xl border border-black/10 dark:border-white/10 p-8" data-testid="register-form">
          <form onSubmit={handleSubmit} className="space-y-6">
            <div>
              <Label htmlFor="name">Name</Label>
              <Input
                id="name"
                type="text"
                value={formData.name}
                onChange={(e) => setFormData({ ...formData, name: e.target.value })}
                required
                className="mt-1"
                data-testid="name-input"
              />
            </div>

            <div>
              <Label htmlFor="email">E-Mail</Label>
              <Input
                id="email"
                type="email"
                value={formData.email}
                onChange={(e) => setFormData({ ...formData, email: e.target.value })}
                required
                className="mt-1"
                data-testid="email-input"
              />
            </div>

            <div>
              <Label htmlFor="password">Passwort</Label>
              <Input
                id="password"
                type="password"
                value={formData.password}
                onChange={(e) => setFormData({ ...formData, password: e.target.value })}
                required
                className="mt-1"
                data-testid="password-input"
              />
            </div>

            <Button
              type="submit"
              className="w-full rounded-full bg-[#0055FF] hover:bg-[#0044CC] text-white"
              disabled={loading}
              data-testid="register-submit-button"
            >
              {loading ? 'Registrieren...' : 'Registrieren'}
            </Button>
          </form>

          <div className="mt-6 text-center text-sm text-[#52525B] dark:text-[#A1A1AA]">
            Bereits ein Konto?{' '}
            <Link to="/login" className="text-[#0055FF] dark:text-[#3377FF] hover:underline font-medium" data-testid="login-link">
              Anmelden
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Register;
